import MyHistory from "./lib/MyHistory";

export * from "./lib/MyHistory";
export * from "./lib/remove/Remove";

export default MyHistory;
